import { render, staticRenderFns } from "./newsModal.vue?vue&type=template&id=51ec39b6&scoped=true&"
import script from "./newsModal.vue?vue&type=script&lang=js&"
export * from "./newsModal.vue?vue&type=script&lang=js&"
import style0 from "./newsModal.vue?vue&type=style&index=0&id=51ec39b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ec39b6",
  null
  
)

export default component.exports